var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10, _g11, _g12, _g13;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBadgeAwardMedalSvgrepoCom(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "-10 0 63.999 63.999",
    id: "Layer_1",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Shape_34_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "12,39.999 12,63.999 22,56 32,63.999 32,39.999   ",
    style: {
      fill: "#CCCCCC"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Shape_35_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "22,56 26,59.199 26,39.999 18,39.999 18,59.199   ",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#75A64B"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Shape_36_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 22,
    r: 22,
    style: {
      fill: "#88C057"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Star_1_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M33.991,18.312c-0.149-0.452-0.542-0.787-1.022-0.875l-6.554-1.202l-3.221-5.572    c-0.235-0.409-0.682-0.663-1.166-0.663c-0.483,0-0.931,0.254-1.166,0.663l-3.22,5.572l-6.554,1.202    c-0.48,0.088-0.873,0.423-1.023,0.875c-0.15,0.45-0.034,0.945,0.303,1.288l4.553,4.639l-0.826,6.304    c-0.062,0.467,0.145,0.93,0.536,1.207c0.233,0.166,0.511,0.25,0.79,0.25c0.19,0,0.382-0.039,0.561-0.12l6.047-2.707l6.046,2.707    c0.18,0.081,0.371,0.12,0.562,0.12c0.279,0,0.556-0.084,0.789-0.25c0.393-0.277,0.598-0.74,0.537-1.207l-0.826-6.304l4.553-4.639    C34.025,19.257,34.142,18.762,33.991,18.312z",
    style: {
      fill: "#FFFFFF"
    }
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", null)), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBadgeAwardMedalSvgrepoCom);
export default __webpack_public_path__ + "static/media/badge-award-medal-svgrepo-com.43071508eb4769b8ad9692792e3ccd30.svg";
export { ForwardRef as ReactComponent };